import moment from 'moment';
import PropTypes from 'prop-types';
import {memo, useMemo} from 'react';

const DatePreview = ({value, format, defaultValue, label}) => {
  const dateValue = useMemo(() => {
    if (value)
      return moment(value).format(format || 'LL').toString();
    return defaultValue || '-';
  }, [defaultValue, format, value]);
  
  return label ? `${label}: ${dateValue}` : dateValue;
};

export default memo(DatePreview);

DatePreview.propTypes = {
  format: PropTypes.string,
  defaultValue: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
